export default __webpack_public_path__ + "static/media/banking_1.6889a0a1.jpg";